@if (erzeugungsanlagenImportReport) {
  <table class="logs">
    <tr>
      <td>
        @if (erzeugungsanlagenImportReport?.success && getNumberOfTransformationWarnings() === 0) {
          <span>
            <img class="smiley-big" src="/assets/innogy-icons/smileys/innogy_picto_smiley.svg">
          </span>
        }
        @if (erzeugungsanlagenImportReport?.success && getNumberOfTransformationWarnings() > 0) {
          <span>
            <img class="smiley-big" src="/assets/innogy-icons/smileys/innogy_picto_smiley_meh.svg">
          </span>
        }
        @if (!erzeugungsanlagenImportReport?.success) {
          <span>
            <img class="smiley-big" src="/assets/innogy-icons/smileys/innogy_picto_smiley_sad.svg">
          </span>
        }
      </td>
      <td>
        @if (erzeugungsanlagenImportReport?.success && getNumberOfTransformationWarnings() === 0) {
          <span
            data-qa="report-valid">
            Sehr schön, die ausgewählte Datei ist fehlerfrei und kann mit großer Wahrscheinlichkeit importiert werden.
            <p>
              Nichtdestotrotz kann es während des eigentlichen Importvorgangs trotzdem noch zu Fehlern kommen, beispielsweise,
              wenn es zwischenzeitlich Änderungen in der Datenbank gab oder sich Parameter des Leitsystems geändert haben.
            </p>
          </span>
        }
        @if (erzeugungsanlagenImportReport?.success && getNumberOfTransformationWarnings() > 0) {
          <span
            data-qa="report-warn">
            Die ausgewählte Datei kann zwar importiert werden, es gibt allerdings ein oder mehrere Hinweise zu Werten, die nicht eindeutig sind. Wir empfehlen, die
            entsprechenden Stellen im Excel-Dokument anzupassen oder nach einem erfolgten Import die hier im TNB-Portal gespeicherten Werte
            mit den im Excel-Dokument angemerkten zu vergleichen.
          </span>
        }
        @if (!erzeugungsanlagenImportReport?.success) {
          <span
            data-qa="report-error">
            Leider müssen wir den Import des Dokuments ablehnen, da entweder das gesamte Dokument oder ein oder mehrere der Erzeuger ungültige oder
            unvollständige Daten enthalten. Gehen Sie bitte anhand der folgenden Liste die Fehler in Ihrem
            Excel-Dokument durch und starten den Import nach der Korrektur erneut. Welche Daten beim Import
            erwartet werden, finden Sie in unserer Ausfüllhilfe.
          </span>
        }
      </td>
    </tr>
  </table>
  @if (areLogsPresent()) {
    <div data-qa="amount-of-errors">
      <h2 data-qa="error-header">
        <span class="error-count">{{ getNumberOfTransformationErrors() + getNumberOfImportErrors() }}</span>
        Fehler@if (getNumberOfWarnings() > 0) {
        <span> und <span
        class="warning-count">{{ getNumberOfWarnings() }} </span> Aufälligkeit{{ getNumberOfWarnings() > 1 ? 'en' : '' }}</span>
      }
      gefunden
    </h2>
    @if (erzeugungsanlagenImportReport.log.length > 0) {
      <span>
        <hr>
          <table class="logs">
            @for (l of erzeugungsanlagenImportReport.log; track l) {
              <tr>
                <td>
                  @if (l.type === 'ErrorImportLogItem') {
                    <img class="smiley-small"
                      src="/assets/innogy-icons/smileys/innogy_picto_smiley_sad.svg">
                    }
                    @if (l.type === 'WarningImportLogItem') {
                      <img class="smiley-small"
                        src="/assets/innogy-icons/smileys/innogy_picto_smiley_meh.svg">
                      }
                    </td>
                    <td>
                      @if (l.type === 'ErrorImportLogItem') {
                        <tnb-error-importlogitem [errorImportLogItem]="l"
                        ></tnb-error-importlogitem>
                      }
                      @if (l.type === 'WarningImportLogItem') {
                        <tnb-warning-importlogitem [warningImportLogItem]="l"
                        ></tnb-warning-importlogitem>
                      }
                    </td>
                  </tr>
                }
              </table>
            </span>
          }
          @for (t of erzeugungsanlagenImportReport?.transformations | nonEmptyLogFilter; track t) {
            <div data-qa="error-detail">
              <hr>
                <h3>Zeile {{t.originalRow + 1}}</h3>
                <table class="logs">
                  @for (l of t.log; track l) {
                    <tr>
                      <td>
                        @if (l.type === 'ErrorTransformationLogItem') {
                          <img class="smiley-small"
                            src="/assets/innogy-icons/smileys/innogy_picto_smiley_sad.svg">
                          }
                          @if (l.type === 'WarningTransformationLogItem') {
                            <img class="smiley-small"
                              src="/assets/innogy-icons/smileys/innogy_picto_smiley_meh.svg">
                            }
                          </td>
                          <td>
                            @if (l.type === 'ErrorTransformationLogItem') {
                              <tnb-error-transformationlogitem [errorTransformationLogItem]="l"
                                data-qa="tnbErrorTransformationlogitem"
                              ></tnb-error-transformationlogitem>
                            }
                            @if (l.type === 'WarningTransformationLogItem') {
                              <tnb-warning-transformationlogitem [warningTransformationLogItem]="l"
                              ></tnb-warning-transformationlogitem>
                            }
                          </td>
                        </tr>
                      }
                    </table>
                  </div>
                }
              </div>
            }
          }
